import React from 'react'
import { Card, CardBody, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import CardHeaderSpan from '../../../../../Utils/CommonComponents/CardHeaderSpan'
import { LeaveYourComment } from '../../../../../Utils/Constants'
import { Btn } from '../../../../../AbstractElements'

export default function BlogContact() {
    return (
        <Col sm={12}>
            <Card className="blog-contact">
                <CardHeaderSpan headingClassName='pb-0 border-0' smallHeading={LeaveYourComment} />
                <CardBody>
                    <Form className="default-form">
                        <Row>
                            <Col md={4} sm={4}>
                                <FormGroup>
                                    <Label htmlFor="name">{'Name'}</Label>
                                    <Input id="name" type="text" placeholder="Enter your name" required />
                                </FormGroup>
                            </Col>
                            <Col md={4} sm={4}>
                                <FormGroup>
                                    <Label htmlFor="email">Email</Label>
                                    <Input id="email" type="email" placeholder="Enter your email" required />
                                </FormGroup>
                            </Col>
                            <Col md={4} sm={4}>
                                <FormGroup>
                                    <Label htmlFor="emailid">Website</Label>
                                    <Input id="emailid" type="text" placeholder="Enter your website" required />
                                </FormGroup>
                            </Col>
                            <div className="col-12">
                                <FormGroup>
                                    <Label htmlFor="exampleFormControlTextarea1">Comment</Label>
                                    <Input type='textarea' id="exampleFormControlTextarea1" placeholder="Write your comment" rows={6}></Input>
                                </FormGroup>
                                <Btn color='primary'>{'Post Comment'}</Btn>
                            </div>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
        </Col>
    )
}